import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { ThinCheckbox } from 'components/common/Styles';
import FlexBox from 'components/common/FlexBox';

const ChecklistItem = ({ data, onDelete }) => {
  const [t] = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/checklist/${data.id}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell> {data.targetAreaName}</TableCell>
      <TableCell> {data.documentName}</TableCell>
      <TableCell> {data.documentCode}</TableCell>
      <TableCell>{data.sharePointContentType}</TableCell>
      <TableCell align='center'>
        <ThinCheckbox size='small' disabled={true} checked={Boolean(data.mandatoryYN)} />
      </TableCell>
      <TableCell align='center'>
        <ThinCheckbox size='small' disabled={true} checked={Boolean(data.defaultYN)} />
      </TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton type='edit' size='small' color='primary' variant='text' tooltip={t('Edit')} onClick={handleEdit} />
          <IconButton type='delete' size='small' color='primary' variant='text' tooltip={t('Delete')} onClick={() => onDelete(data.id)} />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

ChecklistItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ChecklistItem;
